import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	shareArticle: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-article-stateless.share-article',
		defaultMessage: 'Share this article',
		description: 'Title for the sharing article section',
	},

	shareableUrlLabel: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-article-stateless.shareable-url-label',
		defaultMessage: 'Shareable URL',
		description: 'Label for the sharable url textbox',
	},

	copyArticleUrlLabel: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-article-stateless.copy-article-url-label',
		defaultMessage: 'Copy article link',
		description: 'Label for the share url button',
	},

	belongsToThisSpace: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-article-stateless.belongs-to-this-space',
		defaultMessage: 'Space',
		description: 'Label to show which linked space the article belongs to',
	},

	labels: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-article-stateless.labels',
		defaultMessage: 'Labels',
		description: 'Title for section to show labels added to the article',
	},

	tooltipText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-article-stateless.tooltip-text',
		defaultMessage: 'Opens in new tab',
		description: 'tooltip text for space it belongs to',
	},
});
